'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports['default'] = Testimonials;

require('./index.scss');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _quotation_mark = require('../assets/quotation_mark.png');

var _quotation_mark2 = _interopRequireDefault(_quotation_mark);

var _emil = require('../assets/emil.png');

var _emil2 = _interopRequireDefault(_emil);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function Testimonials() {
    return _react2['default'].createElement(
        'div',
        { style: { backgroundColor: '#F7F8F9' } },
        _react2['default'].createElement(
            'div',
            { className: 'm-careers-page--testimonials' },
            _react2['default'].createElement(
                'div',
                { style: { maxWidth: 1120, margin: 'auto' } },
                _react2['default'].createElement('img', { src: _quotation_mark2['default'] }),
                _react2['default'].createElement(
                    'p',
                    null,
                    'Nobody is afraid to ask any questions because they know that immediately they will be met with a response, or an idea, or an \'I don\u2019t know but let\u2019s find out.\''
                ),
                _react2['default'].createElement(
                    'div',
                    { className: 'm-careers-page--testimonials--profile' },
                    _react2['default'].createElement('img', { src: _emil2['default'] }),
                    _react2['default'].createElement(
                        'div',
                        { className: 'm-careers-page--testimonials--profile-info' },
                        _react2['default'].createElement(
                            'p',
                            { className: 'm-careers-page--testimonials--profile-name' },
                            'Emil Gallardo'
                        ),
                        _react2['default'].createElement(
                            'p',
                            { className: 'm-careers-page--testimonials--profile-title' },
                            'Product Manager'
                        )
                    )
                )
            )
        ),
        _react2['default'].createElement(
            'div',
            { className: 'm-careers-page--testimonials--featured row' },
            _react2['default'].createElement(
                'div',
                { className: 'm-careers-page--testimonials--featured--muse columns small-12 medium-4 large-4' },
                _react2['default'].createElement(
                    'h2',
                    null,
                    'WE WERE FEATURED ON \'THE MUSE\''
                ),
                _react2['default'].createElement(
                    'h2',
                    null,
                    'CHECK US OUT'
                ),
                _react2['default'].createElement('a', { href: 'https://www.themuse.com/companies/hellosign/office', target: '_blank', rel: 'noopener noreferrer' })
            ),
            _react2['default'].createElement(
                'div',
                { className: 'm-careers-page--testimonials--featured--glassdoor columns small-12 medium-4 large-4' },
                _react2['default'].createElement('a', { href: 'https://www.glassdoor.com/Overview/Working-at-HelloSign-EI_IE879257.11,20.htm', target: '_blank', rel: 'noopener noreferrer' })
            ),
            _react2['default'].createElement(
                'div',
                { className: 'm-careers-page--testimonials--featured--hirepalooza columns small-12 medium-4 large-4 end' },
                _react2['default'].createElement('a', { href: 'http://blog.hellosign.com/hellosign-at-hirepalooza-2015/', target: '_blank', rel: 'noopener noreferrer' })
            )
        )
    );
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/landing-pages/components/careers-page/testimonials/index.jsx
 ** module id = 1576
 ** module chunks = 0
 **/